module.exports = __webpack_public_path__ + "img/re-result-2.0d259c8a.jpg";